import React from "react";
import styles from "./Assessment2Fitting.module.css";
import quiz from "../../../json/Quiz.json";
import Assessment2Shell, { RailLens } from "../Assessment2Shell/Assessment2Shell";
import { CheckIcon } from "../icons/icons";

const cfg = quiz.assessment2;
const f = cfg.fitting;

/* "anona" ships without a hyphen glyph, so render just that character
   in the Mokoko fallback instead of letting it drop out. */
const renderHyphens = (text) =>
  String(text)
    .split(/(-)/g)
    .map((part, index) =>
      part === "-" ? (
        <span key={index} className={styles.hyphenFamily}>
          -
        </span>
      ) : (
        <span key={index}>{part}</span>
      ),
    );

/* Final step — "Fitting Set Request". A Yes / Not-now choice; when the
   practice is interested the Q7 readiness groups appear as pill chips. */
const Assessment2Fitting = ({
  fittingAnswer,
  onSelectFitting,
  finalQuestion,
  answers,
  onChange,
  interested,
  onExit,
  onBack,
  onSubmit,
  submitDisabled,
  submitting,
  submitError,
}) => {
  const rail = (
    <>
      <span className={styles.railEyebrow}>{f.eyebrow}</span>
      <h1 className={styles.railTitle}>{f.title}</h1>
      <p className={styles.railText}>{f.railText}</p>
      <RailLens />
    </>
  );

  const groupValue = answers[finalQuestion?.id] || {};

  return (
    <Assessment2Shell
      stepIndex={3}
      allComplete
      rail={rail}
      railFilled
      onExit={onExit}
      onBack={onBack}
      onNext={onSubmit}
      nextLabel={submitting ? "Submitting…" : f.submitLabel}
      nextDisabled={submitDisabled}
      stackFooter={interested}
    >
      <div className={styles.mainHead}>
        <h2 className={styles.mainTitle}>{f.heading}</h2>
        <p className={styles.mainDesc}>{f.description}</p>
      </div>

      {/* ---- Yes / Not now choice cards ---- */}
      <div className={styles.fitCards} role="radiogroup" aria-label={f.heading}>
        {f.options.map((opt) => {
          const selected = fittingAnswer?.value === opt.value;
          return (
            <button
              key={opt.value}
              type="button"
              role="radio"
              aria-checked={selected}
              className={`${styles.fitCard} ${selected ? styles.fitCardOn : ""}`}
              onClick={() => onSelectFitting(opt)}
            >
              <span className={styles.fitMark}>{opt.value === "yes" ? "✓" : "—"}</span>
              <span className={styles.fitBody}>
                <span className={styles.fitLabel}>{opt.label}</span>
                <span className={styles.fitSub}>{opt.sub}</span>
              </span>
              <span className={`${styles.radio} ${selected ? styles.radioOn : ""}`} aria-hidden="true">
                <CheckIcon size={11} />
              </span>
            </button>
          );
        })}
      </div>

      {submitError && <p className={styles.submitError}>{submitError}</p>}

      {/* ---- Q7 readiness chips (only when interested) ---- */}
      {interested && finalQuestion && (
        <div className={styles.readiness}>
          <h3 className={styles.readinessTitle}>{renderHyphens(f.readinessTitle)}</h3>
          {finalQuestion.groups.map((group, gi) => (
            <div key={group.label} className={styles.chipGroup}>
              <p className={styles.chipGroupLabel}>{group.label}</p>
              <div className={styles.chips} role="radiogroup" aria-label={group.label}>
                {group.options.map((opt) => {
                  const selected = groupValue[gi]?.label === opt.label;
                  return (
                    <button
                      key={opt.label}
                      type="button"
                      role="radio"
                      aria-checked={selected}
                      className={`${styles.chip} ${selected ? styles.chipOn : ""}`}
                      onClick={() => onChange(finalQuestion.id, opt, gi)}
                    >
                      {opt.label}
                    </button>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
      )}
    </Assessment2Shell>
  );
};

export default Assessment2Fitting;
